/**
 * Where "back" from Settings goes: to the screen Settings was opened from.
 *
 * Settings is reached from the operator's menu on the rail, which is on every
 * screen. A driver who opens it from Move Pallets expects back to return to
 * Move Pallets, not to Home (owner, 2026-10-12). The barcode gun setup and
 * the scan test sit under Settings and back out to it, so the three are one
 * place for this purpose: the way back is remembered when that place is
 * entered and kept while moving around inside it.
 */

const SETTINGS_PATHS = ['/settings', '/gun', '/scan']

/** Screens with no way back to them: there is nothing there to return to. */
const NOT_A_RETURN = ['/login']

export const DEFAULT_RETURN = '/'

/** The name Move Pallets keeps its forks under for the return (heldScans.ts). */
export const MOVE_FORKS = 'move-forks'

type Place = { path: string, fullPath: string }

export function isSettingsPath(path: string): boolean {
  return SETTINGS_PATHS.includes(path)
}

/** The way back, given a navigation that is about to happen. */
export function nextReturn(current: string, to: Pick<Place, 'path'>, from: Place): string {
  if (!isSettingsPath(to.path) || isSettingsPath(from.path)) return current
  return NOT_A_RETURN.includes(from.path) ? DEFAULT_RETURN : from.fullPath
}

/**
 * Whether Settings is being left for somewhere other than the screen it was
 * opened from — in which case what that screen was keeping for the return
 * (the forks on Move Pallets) is no longer wanted.
 */
export function leftSettingsElsewhere(returnTo: string, to: Pick<Place, 'path'>, from: Pick<Place, 'path'>): boolean {
  if (!isSettingsPath(from.path) || isSettingsPath(to.path)) return false
  return to.path !== pathOf(returnTo)
}

function pathOf(fullPath: string): string {
  return fullPath.split(/[?#]/)[0] ?? fullPath
}
